export interface AuthTestimonial {
    // Translation keys, not literals: the panel renders next to a fully localized form, so an English
    // quote on a Portuguese page reads as a bug. Keyed by person slug (not by index) so reordering or
    // adding testimonials never re-points existing translations at the wrong quote.
    quoteKey: string;
    roleKey: string;
    authorName: string;
    avatarInitials: string;
    avatarColor: string;
    avatarImage?: string;
    companyLogo?: string;
}

export const AUTH_TESTIMONIALS: AuthTestimonial[] = [
    {
        quoteKey: 'auth.testimonial.tiago-lopes.quote',
        roleKey: 'auth.testimonial.tiago-lopes.role',
        authorName: 'Tiago Lopes',
        avatarInitials: 'TL',
        avatarColor: 'var(--mui-palette-info-main)',
        avatarImage: '/testimonials/tiago_lopes.png',
        companyLogo: '/testimonials/eco_online.png',
    },
    {
        quoteKey: 'auth.testimonial.antonio-vairinhos.quote',
        roleKey: 'auth.testimonial.antonio-vairinhos.role',
        authorName: 'António Vairinhos',
        avatarInitials: 'AV',
        avatarColor: 'var(--mui-palette-secondary-light)',
        avatarImage: '/testimonials/antonio_vairinhos.png',
        companyLogo: '/testimonials/quinta_lago.png',
    },
    {
        quoteKey: 'auth.testimonial.anabela-oliveira.quote',
        roleKey: 'auth.testimonial.anabela-oliveira.role',
        authorName: 'Anabela Oliveira',
        avatarInitials: 'AO',
        avatarColor: 'var(--mui-palette-error-light)',
        avatarImage: '/testimonials/anabela_oliveira.png',
        companyLogo: '/testimonials/hoteis_lux.png',
    },
    {
        quoteKey: 'auth.testimonial.sara-ferrao.quote',
        roleKey: 'auth.testimonial.sara-ferrao.role',
        authorName: 'Sara Ferrão',
        avatarInitials: 'SF',
        avatarColor: 'var(--mui-palette-warning-main)',
        avatarImage: '/testimonials/sara_ferrao.png',
        companyLogo: '/testimonials/one_clinics.png',
    },
];
